import { createContext } from "react";
import { NavigationGuardContextValue } from "./types";

export const NavigationGuardContext =
  createContext<NavigationGuardContextValue | null>(null);
